import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { environment } from '../../../environments/environment';
import { AppEnvironmentName } from '../../shared/model/app-environment-name.enum';
import { NavService } from '../../core/services/nav.service';

/**
 * Guard to restrict route access to DEV and STG environments only.
 * Redirects to error page if accessed in other environments.
 */
export const environmentCheckGuard: CanActivateFn = (_route, _state) => {
  const logger = inject(NGXLogger);
  const navService = inject(NavService);

  logger.debug(
    'environmentCheckGuard: checking environment',
    environment.envName,
  );

  const allowedEnvironments = [AppEnvironmentName.DEV, AppEnvironmentName.STG];

  if (!allowedEnvironments.includes(environment.envName)) {
    logger.warn(
      'environmentCheckGuard: access denied for environment',
      environment.envName,
    );
    navService.navigateToErrorPage();
    return false;
  }

  return true;
};
